import React from "react";
import FlightHotelForm from "../Components/FlightHotelForm";

function HolidayPackages(){
    return(
        <>
        <section className="breadcrumb-main pb-15 pt-15 bookingHeaderSection" >
            <div className="section-shape section-shape1 top-inherit bottom-0" ></div>
            <div className="breadcrumb-outer">
                <div className="container">
                    <div className="breadcrumb-content text-center">
                        <h1 className="mb-3">Holiday Packages</h1>
                    </div>    
                    <div className="row" >
                        <FlightHotelForm />
                    </div>
                    
                </div>
            </div>
        </section>    
        </>
    )
}
export default HolidayPackages;